import { useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { State } from 'common/interfaces/state';
import { Company } from 'unit-account/interfaces/company';
import { resetIntercomIdentify, setIntercomIdentify } from '../intercom';
import { resetPosthogUser, setPosthogIdentify } from '../posthog';


interface StateProps {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  intercomUserHash: string;
  hasAvatar: boolean;
  selectedCompanyId: number;
  companies: Company[];
}

interface Props extends StateProps {
  children?: React.ReactElement;
}

const GtmContextComponent: React.FC<Props> = (props) => {
  const {
    id,
    email,
    firstName,
    lastName,
    hasAvatar,
    selectedCompanyId,
    companies,
    intercomUserHash,
  } = props;

  const user = useMemo(() => {
    return { id, email, name: `${firstName} ${lastName}` };
  }, [id, email, firstName, lastName]);
  const company = useMemo(() => {
    return companies && companies.find(x => x.id === selectedCompanyId);
  }, [selectedCompanyId, companies]);
  const [isIntercomInstalled, setIsIntercomInstalled] = useState(false);

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (window.Intercom) {
        setIsIntercomInstalled(true);
        clearInterval(intervalId);
      }
    }, 200);

    setTimeout(() => clearInterval(intervalId), 10000);
  });

  useEffect(() => {
    if (!id) {
      resetPosthogUser();
      resetIntercomIdentify();
    }
  }, [id]);

  useEffect(() => {
    setPosthogIdentify(user, company);
  }, [user, company]);

  useEffect(() => {
    setIntercomIdentify(user, company, intercomUserHash, hasAvatar);
  }, [user, company, hasAvatar, intercomUserHash, isIntercomInstalled]);

  return props.children;
};

const mapStateToProps = (state: State): StateProps => {
  const {
    id,
    email,
    firstName,
    lastName,
    hasAvatar,
    companies,
    intercomUserHash,
  } = state.account || {};

  return {
    id,
    email,
    firstName,
    lastName,
    hasAvatar,
    companies,
    intercomUserHash,
    selectedCompanyId: state.persistedStorage.selectedCompanyId,
  };
};

export const GtmContext = connect(mapStateToProps)(GtmContextComponent);
